import {Component, OnInit, ViewChild, TemplateRef} from '@angular/core';
import {Grid} from '../../../../shared/Models/grid';
import {Observable, Subject} from 'rxjs';
import {Supplier} from '../../../Models/Supplier';
import {Part} from '../../../Models/Part';
import {Router} from '@angular/router';
import {PartsService} from '../../../Services/parts.service';
import {BroadcastService} from '../../../../shared/Services/broadcast.service';
import { createArchivePartsGridConfig } from '../configs';

@Component({
  selector: 'app-archive-parts-view',
  templateUrl: './archive-parts-view.component.html',
  styleUrls: ['./archive-parts-view.component.scss']
})
export class ArchivePartsViewComponent implements OnInit {

  public grid: Grid;
  public partId: number;
  public partName: string;
  public parts: Observable<Supplier[]>;
  public partsLoading = false;
  public partsinput$ = new Subject<string>();
  public selectedPart: Part;
  @ViewChild('partRowDetail', {static: false}) partRowDetail: TemplateRef<any>;
  @ViewChild('reAddModel', {static: false}) reAddModel = null;

  constructor(
    private router: Router, 
    private partsService: PartsService, 
    private broadcastService: BroadcastService
  ) {}

  ngOnInit() {
    this.grid = createArchivePartsGridConfig(
      this.router,
      this.partsService,
      this.partRowDetail,
      (row: Part) => this.onReAdd(row)
    );
  }

  private onReAdd(row: Part): void {
    this.partId = row.id;
    this.partName = `<b>${row.name}</b>`;
    this.reAddModel.show();
  }

  reAdd() {
    this.partsService.reAdd(this.partId).subscribe(() => {
      this.broadcastService.broadcast('refreshGrid', 'getPart');
      this.reAddModel.hide();
    });
  }
}
